import { render } from "./JourneyPage.vue?vue&type=template&id=3d836002&scoped=true"
import script from "./JourneyPage.vue?vue&type=script&lang=js"
export * from "./JourneyPage.vue?vue&type=script&lang=js"

import "./JourneyPage.vue?vue&type=style&index=0&id=3d836002&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d836002"]])

export default __exports__